import styled from 'styled-components';

import {
  colorBlack900,
  colorPrimary400,
  colorWhite,
  fontFamilyPrimary,
} from '@/styleUtils';

export const TablesNav = styled.div`
  display: flex;
  gap: 24px;
  padding: 0 24px;
  background-color: ${colorWhite};
  border-radius: 12px;
  overflow: auto;
`;

export const TablesTab = styled.button`
  padding: 20px 0 17px;
  font: 700 12px/16px ${fontFamilyPrimary};
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${colorBlack900};
  white-space: nowrap;
  cursor: pointer;
  border: none;
  background-color: transparent;

  &:hover,
  &:focus,
  &:active {
    color: ${colorPrimary400};
    box-shadow: inset 0 -3px 0 ${colorPrimary400};
  }

  ${({ $isMoving }) => $isMoving && `pointer-events: none;`};
`;
